export const findArrayIndexByPropertyName = (array, attr, value) => {
  if (!array || array.length === 0) {
    return -1;
  }
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i;
    }
  }
  return -1;
};
